module.exports = __webpack_public_path__ + "static/media/pflanzy.f3e5ca45.gif";